import { canv } from '@/canv/global.js'

export class shapeManualInput {

    constructor() {

    }

    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width - 2 * horizontalPadding;
        var allowedHeight = height * 4/5 - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + height/5 + textPart.lines[0].textHeight + height * 4/5 / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        var r = height / 30;
        if (width < 2 * r) r = width / 2;
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y + height/5 + r);
        canv.ctx.arcTo(x, y + height/5, x + width, y, r);
        canv.ctx.arcTo(x + width, y, x + width, y + height, r);
        canv.ctx.arcTo(x + width, y + height, x, y + height, r);
        canv.ctx.arcTo(x , y + height, x, y, r);
        canv.ctx.lineTo(x, y + height/5 + r);
    }

    getAvatar(color) {
        return `
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 23.9838C0 18.5879 2.89712 14.0039 6.81328 13.2036L70.8132 0.122835C75.6502 -0.865745 80 4.23859 80 10.903V69.0993C80 75.1198 76.4182 80 72 80H8C3.58172 80 0 75.1198 0 69.0993V23.9838Z"
        fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.20589 3.62992L2.2059 3.62992L22.2059 0.523249C23.3943 0.338648 24.5 1.29281 24.5 2.58946V16.4111C24.5 17.5814 23.5882 18.5 22.5 18.5H2.5C1.41175 18.5 0.5 17.5814 0.5 16.4111V5.69614C0.5 4.64819 1.23827 3.78022 2.20589 3.62992Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
